<template>
  <div class="single-table">
    <div class="table-head">
        <h4>{{$t(title)}}</h4>
    </div>
    <div class="table-body">
      <div class="top-fields">
        <div v-for="(element, index) in header" :key="index" :class="element.class">
          <span>{{$t(element.title)}}</span>
        </div>
      </div>
      <div class="main-field-wrap">
        <div class="side-fields" v-if="sideItems != null && sideItems.length > 0">
          <div  v-for="(element, index) in sideItems" :key="index" :class="element.class">
            <span>{{$t(element.title)}}</span>
          </div>
        </div>
        <div class="main-field-block">
          <div class="row" v-for="(rowStakes, index) in stakes" :key="index">
            <div class="main-field"
              v-for="(element, index) in rowStakes"
              @click="selectedItem(element)"
              :key="index"
              :class="{'field-selected' :activeStake === element}">
                <span v-if="element.Factor > 0">{{format(element.Factor)}}</span>
                <span v-else></span>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
    <div class="no-more-bets" v-if="!isBettingEnabled && !resultTable"><img src="https://cloud.aleacontrol.com/media/vDogs/bet-placed.png" alt="no-more-bets"></div>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'
import vuexStore from '../../../store/vuexStore'

import select from '../../../../src/assets/audio/select.mp3'

export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    matchNo: {
      type: Number
    },
    isBetPlaced: {
      type: Boolean,
      default: false
    },
    isBettingEnabled: {
      type: Boolean,
      default: true
    },
    activeStake: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    header: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    sideItems: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    resultTable: {
      type: Boolean,
      default: false
    },
    stakes: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value / 100, this.getLanguageCodeForNumbers())
    },
    selectedItem: function (stake, selectedStake) {
      if (this.isBettingEnabled && stake.Factor > 0) {
        if (this.hasAudioEnabled) {
          var audio = new Audio(select)
          audio.play()
        }
        eventBus.onSelectedStakeVDog(stake)
      }
    }
  }
}
</script>
